import { useEffect, useState } from "react";
import NewsRow from "../../components/news/NewsRow";
import { getNewsByCategory } from "../../api/news.service";
import Header from "../../components/Header";
import "./News.css";

const News = () => {
  const [entertainment, setEntertainment] = useState([]);
  const [sports, setSports] = useState([]);
  const [technology, setTechnology] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    getNewsByCategory("entertainment").then(setEntertainment);
    getNewsByCategory("sports").then(setSports);
    getNewsByCategory("technology").then(setTechnology);
  }, []);

  return (
    
    <div className="newsPage">
      <Header
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onProfile={() => setProfileOpen(true)}
      />
      <NewsRow title="Entertainment" articles={entertainment} />
      <NewsRow title="Sports" articles={sports} />
      <NewsRow title="Technology" articles={technology} />
    </div>
  );
};

export default News;
